<template>
  <div class="gap-20px p-20px flex h-full w-full flex-col" :class="sizeClass">
    <slot />
  </div>
</template>

<script>
import { computed } from "@vue/runtime-core";
import { useCustomValidator } from "../../../compostables/useValidators";

export default {
  props: {
    size: {
      type: String,
      required: false,
      default: "large",
      validator(value) {
        return useCustomValidator(["small", "normal", "large"], value);
      },
    },
  },
  setup(props) {
    const sizeClass = computed(() => ({
      "md:p-40px": props.size === "normal",
      "md:p-40px xl:p-60px": props.size === "large",
    }));

    return {
      sizeClass,
    };
  },
};
</script>
